export enum BillingCycle {
    Weekly = 1,
    BiWeekly = 2,
    FourWeekly = 3,
    SemiMonthly = 4,
    Monthly = 5,
    Custom = 6,
}
export enum PaymentTerm {
    Net_Seven = 1,
    Net_Fifteen = 2,
    Net_Thirty = 3,
    Net_Forty_Five = 4,
    Net_Sixty = 5,
    Pay_On_Pay = 6,
}
export enum POStatus {
    To_Join = 1,
    Joined = 2,
    Fizzled = 3,
    Ended = 4,
}

export interface IPurchaseOrder {
    pO_ID?: number,
    req_ID?: number,
    recruiter_ID?: number,
    salesManager_ID?: number,
    salesmanager?: string,
    prime_Vendor?: number,
    consultant_ID?: number,
    consultant_Name?: string,
    bRate?: number | null,
    sRate?: number | null,
    mRate?: number,
    consultant_Employeer_Sub_Vendor?: number,
    sub_Vendor_Company?: string,
    sub_Vendor_Contact_Person?: string,
    sub_Vendor_Contact_Person_Email?: string,
    sub_Vendor_Contact_Person_Phone?: string,
    sub_Vendor_Contact_Person_CellNo?: string,
    sub_Vendor_Contact_Person_Ext?: string,
    prime_Vendor_Billing_Cycle?: BillingCycle,
    prime_Vendor_Payment_Term?: PaymentTerm,
    sub_Vendor_Billing_Cycle?: BillingCycle,
    sub_Vendor_Payment_Term?: PaymentTerm,
    project_Client_Name?: string,
    project_Name?: string,
    pM_Name?: string,
    pM_Email?: string,
    phone?: string,
    ext?: string,
    project_Start_Date?: Date,
    project_Start_Date1?: string,
    project_End_Date?: Date,
    project_End_Date1?: string,
    createdon?: Date,
    pO_Status?: POStatus,
    exp_End_Date?: Date,
    sub_Vendor_ID?: number,
    branch_Name?: string,
    brancPer?: number,
    headOffPer?: number,
    pO_Date?: Date,
    tentitive_Start_Date?: Date,
    fizzelReason?: string,
    req_Job_Title?: string,
    req_Duration?: string,
    city_Name?: string,
    state_Name?: string,
    salesBranch?: string,
    consultant_Email_id?: string,
    consultant_Job_Title?: string,
    consultant_Cell_No?: string,
    consultant_Home_No?: string,
    visa_Name?: string,
    vendor_Company_Name?: string,
    pO_Sub_Vendor_Company?: string,
    contact_Person_EmailID?: string,
    contact_Person_Name?: string,
    salesCompanyName?: string,
    company_Name_Sales?: string,
    recruiterBranch?: string,
    company_Name_Recruiter?: string,
    recruiterCompany?: string,
    req_CategoryName?: string,
    dollerRate?: any;
    pV_Referal?: boolean,
    company_ID_Sales?: number,
    timesheet_Week_Start_Day?: number,
}